/** GERP 생산거래처 신규/변경(120) — 레거시 appr_edit_forms_new_esg */
export const PRODUCTION_VENDOR_TYPE = 120;

export const isProductionVendorType = (apvType: number): boolean =>
  apvType === PRODUCTION_VENDOR_TYPE;

export const PRODUCTION_VENDOR_MISSING_MESSAGE = '결재할 건을 선택해주세요.';

/** GERP 미상신 결재 건 — 키는 GERP 응답 그대로 */
export type ProductionVendorCandidate = {
  sysId: string;
  aprvId: string;
  aprvTypcd: string;
  title?: string | null;
  docTit?: string | null;
};

type Value = string | number | null | undefined;

/** GERP 120 본문(display.content) — 키는 GERP 응답 그대로 */
export type ProductionVendorBasic = {
  custCode?: Value;
  custName?: Value;
  repName?: Value;
  busoNo?: Value;
  corpNo?: Value;
  busiType?: Value;
  busiCond?: Value;
  post?: Value;
  addr?: Value;
  tel?: Value;
  email?: Value;
  black?: Value;
  blackReason?: Value;
};

export type ProductionVendorBank = {
  bankCode?: Value;
  bankAccount?: Value;
  payMethod?: Value;
  payWhen?: Value;
  bankCountry?: Value;
  payDate?: Value;
  useYn?: Value;
};

export type ProductionVendorVtpm = {
  dtlCd?: Value;
  dtlCdNm?: Value;
  checked?: Value;
};

export type ProductionVendorFactory = Record<
  | 'seq'
  | 'manuName'
  | 'judgedate'
  | 'aMind'
  | 'aSafety'
  | 'aQuality'
  | 'bJaCheck'
  | 'bJaManage'
  | 'bEquipment'
  | 'bSkill'
  | 'bProcess'
  | 'bSupervisor'
  | 'cInspection'
  | 'cOutsourcing'
  | 'cBad'
  | 'cEqCheck'
  | 'cDefect'
  | 'cSubjaCheck'
  | 'dKeepManage'
  | 'dJobMoving'
  | 'dJobLight'
  | 'eInspect'
  | 'ePl'
  | 'eqLevel'
  | 'jobLevel'
  | 'quLevel'
  | 'planRemark'
  | 'valuer',
  Value
>;

export type ProductionVendorContent = {
  aprvTypcd?: string | null;
  today?: Value;
  basicBefore?: ProductionVendorBasic | null;
  basicAfter?: ProductionVendorBasic | null;
  basicDiff?: Record<string, boolean> | null;
  bankBefore?: ProductionVendorBank[] | null;
  bankAfter?: ProductionVendorBank[] | null;
  brands?: { brand?: Value; nameKor?: Value; stopped?: boolean }[] | null;
  vtpmLeft?: ProductionVendorVtpm[] | null;
  vtpmRight?: ProductionVendorVtpm[] | null;
  tradeStartReason?: Value;
  accountBrand?: { codevalue?: Value } | null;
  card01?: Record<string, Value> | null;
  card02?: Record<string, Value>[] | null;
  card03?: Record<string, Value>[] | null;
  factory?: ProductionVendorFactory[] | null;
  pay?: Record<string, Value>[] | null;
  rel?: Record<string, Value>[] | null;
};

export type ProductionVendorDraftSource = {
  code: number;
  attributes: Record<string, unknown>;
  display: {
    candidates: ProductionVendorCandidate[] | null;
    selection: string[] | null;
    subject: string | null;
    content: ProductionVendorContent | null;
  };
};

/** 저장 attributes 와 같은 모양 */
export type ProductionVendorState = {
  systemId: string;
  approvalTypeCode: string;
  approvalId: string;
  /** 작성 시점 본문 HTML */
  content: string | null;
};

const text = (v: unknown): string | null =>
  typeof v === 'string' && v.trim() ? v : null;

export const parseProductionVendorAttributes = (
  attributes: Record<string, unknown> | null | undefined,
): ProductionVendorState | null => {
  const systemId = text(attributes?.systemId);
  const approvalTypeCode = text(attributes?.approvalTypeCode);
  const approvalId = text(attributes?.approvalId);
  if (!attributes || !systemId || !approvalTypeCode || !approvalId) return null;
  return {
    systemId,
    approvalTypeCode,
    approvalId,
    content: text(attributes.content),
  };
};

export const parseProductionVendorContent = (
  attributes: Record<string, unknown> | null | undefined,
): string | null => text(attributes?.content);

export const buildProductionVendorAttributes = (
  state: ProductionVendorState | null | undefined,
) =>
  state
    ? {
        systemId: state.systemId,
        approvalTypeCode: state.approvalTypeCode,
        approvalId: state.approvalId,
        content: state.content,
      }
    : null;

export const checkProductionVendorBeforeSave = (
  state: ProductionVendorState | null | undefined,
): string | null => (state?.content ? null : PRODUCTION_VENDOR_MISSING_MESSAGE);

export const productionVendorKey = (
  state: ProductionVendorState | null | undefined,
) => state?.approvalId ?? '';

/** 레거시 콤보 문구 — 건 제목(DOC_TIT) */
export const buildProductionVendorCandidateLabel = (
  c: ProductionVendorCandidate,
) => c.docTit?.trim() || c.title?.trim() || c.aprvId;
